import styled from 'styled-components';
import TaskCreation from './component';

export default styled(TaskCreation)`
  position: fixed;
  bottom: 0;
  background-color: white;
  width: 320px;
  height: 266px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 4px 0 14px 0 rgba(0, 0, 0, 0.2);

  .header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-weight: bold;
    }

    &__close {
      cursor: pointer;
    }
  }

  .selectors {
    display: flex;
    justify-content: space-between;
  }

  .action {
    button {
      width: 100%;
    }
  }
`;
